import * as React from "react";
const TickIconSvg = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.00004 14.6666C11.6667 14.6666 14.6667 11.6666 14.6667 7.99992C14.6667 4.33325 11.6667 1.33325 8.00004 1.33325C4.33337 1.33325 1.33337 4.33325 1.33337 7.99992C1.33337 11.6666 4.33337 14.6666 8.00004 14.6666Z"
      stroke="#851D1E"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.16663 7.99995L7.05329 9.88661L10.8333 6.11328"
      stroke="#851D1E"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default TickIconSvg;
